import React, {useState, useRef,useEffect } from 'react';
import { Row, Col } from 'antd';
import DeviceMap, { DEFAULT_ZOOM } from './DeviceMap';
import { useSelector} from 'react-redux';
import { iotDevice } from '@iso/services';
import Box from '@iso/components/utility/box';
import DeviceTable from './DeviceTable';
import AlertDevice from './AlertDevice';
import SafeFarmWrapper from './SafeFarm.styles'; 
import IntlMessages from '@iso/components/utility/intlMessages';
import _ from 'lodash';
import L from 'leaflet';
import { propertyService } from '@iso/services';

const SafeFarm = () => {
  const mapRef = useRef();
  const activePropertyId = useSelector(
    (state) => state.property.activePropertyId
  );
  const [positionDevice, setPositionDevice] = useState();
  const [centerPoint, setCenterPoint] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMarkerAlert, setShowMarkerAlert] = useState(false);
  const [propertyPosition, setPropertyPosition] = useState(null);
  const [primaryObjects, setPrimaryObjects] = useState([]);
  // Once the map has been fitted to the devices nothing else may move it: on a
  // slow connection the property lookup resolves after this one and would
  // otherwise reset the viewport.
  const hasFittedDevices = useRef(false);

  const getPositionDevice = () => {
    let locations = [];
    iotDevice.getDeviceLocation(activePropertyId).then((res) => {
      const { current = {} } = mapRef;
      const { leafletElement: map } = current;
      if (res.code === "0000") {
        setPositionDevice(res.locations);
        setLoading(false);

        if (map && res.locations && res.locations.length > 0) {
          _.forEach(res.locations, (data) => {
            if (data.latitude && data.longitude) {
              locations.push([data.latitude, data.longitude]);
            }
          });
          if (locations.length) {
            hasFittedDevices.current = true;
            if (locations.length > 1) {
              const bounds = new L.LatLngBounds(locations);
              map.fitBounds(bounds, { padding: [30, 30] });
            } else {
              map.setView(locations[0], DEFAULT_ZOOM);
            }
          }
        }
      }
    });
  };

  const viewProperty = (id) => {
    propertyService.viewProperty(id).then(res => {
      if(res.code === '0000'){
        // Set primary objects (polygons)
        if (res.primary_objects) {
          setPrimaryObjects(res.primary_objects);
        }

        // Use polygon centroid if available, otherwise use property lat/lng
        let centerLat = res.property.lat;
        let centerLng = res.property.lng;

        if (res.primary_objects && res.primary_objects.length > 0) {
          const firstObject = res.primary_objects[0];
          if (firstObject.lat_centroid && firstObject.lng_centroid) {
            centerLat = firstObject.lat_centroid;
            centerLng = firstObject.lng_centroid;
          }
        }

        // Only a fallback for "no devices to fit" — never override the fit.
        if (centerLat != null && centerLng != null && !hasFittedDevices.current) {
          setPropertyPosition([centerLat, centerLng]);
        }
      }
    })
  }

  useEffect(() => {
    if(activePropertyId){
      hasFittedDevices.current = false;
      setPropertyPosition(null);
      viewProperty(activePropertyId);
    }
  },[activePropertyId]);

  return (
    <SafeFarmWrapper>
      <Row gutter={[15, 15]}>
        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Box className="statisticMap-cards">
            <DeviceMap
              mapRef={mapRef}
              propertyId={activePropertyId}
              setLoading={setLoading}
              loading={loading}
              getPositionDevice={getPositionDevice}
              centerPoint={centerPoint}
              positionDevice={positionDevice}
              showMarkerAlert={showMarkerAlert}
              setShowMarkerAlert={setShowMarkerAlert}
              propertyPosition={propertyPosition}
              primaryObjects={primaryObjects}
              hasFittedDevicesRef={hasFittedDevices}
            />
          </Box>
        </Col>
      </Row>
      <Row gutter={15} className="tablesCust">
        <Col xl={12} md={24} sm={24} xs={24}>
          <Box className="statistic-cards">
            <h1>
              <IntlMessages id="safeFarmPage.alertHistory" />
            </h1>
            <AlertDevice
              propertyId={activePropertyId}
              setPositionDevice={setPositionDevice}
              setCenterPoint={setCenterPoint}
              setShowMarkerAlert={setShowMarkerAlert}
            />
          </Box>
        </Col>
        <Col xl={12} md={24} sm={24} xs={24}>
          <Box className="statistic-cards">
            <DeviceTable
              propertyId={activePropertyId}
              getPositionDevice={getPositionDevice}
            />
          </Box>
        </Col>
      </Row>
    </SafeFarmWrapper>
  );
};

export default SafeFarm;

